import { useParams, useSearchParams } from 'react-router-dom';
import { useConnectedUser, UserType } from '../context/connected-user.context';
import { useEffect, useState } from 'react';
import { SectionTitle } from '../design-system/title';
import { StakeRoundDetailFromId } from '../components/round/staking/staking-view';
import { Round } from '../web3/model/round.model';

export const SaleRoundPage: React.FC = () => {
    const { saleRoundId } = useParams();
    const [searchParams] = useSearchParams();
    const userType = (searchParams.get('userType') as UserType) ?? 'USER';

    const cdkContract = useConnectedUser().contract!;
    const [saleRound, setSaleRound] = useState<Round | undefined>(undefined);
    const [stackingRoundId, setStackingRoundId] = useState<string | undefined>('');

    const getSaleRoundDetails = async () => {
        if (cdkContract && saleRoundId) {
            const round = await cdkContract.roundFacet.getRoundDetails(saleRoundId);
            setSaleRound(round);
        }
    };

    const getStackingRoundId = async () => {
        if (cdkContract && saleRoundId) {
            const stackingId = await cdkContract.roundFacet.getStakingId(saleRoundId);
            setStackingRoundId(stackingId);
        }
    };

    useEffect(() => {
        if (cdkContract) {
            getSaleRoundDetails();
            getStackingRoundId();
        }
    }, [cdkContract]);

    return (
        <>
            <SectionTitle title={`Sale Round ${saleRoundId}`} />
            {saleRound && (
                <div>
                    <div>
                        <div>Allocation percentage: {saleRound.allocation}</div>
                        <div>Token price: {saleRound.tokenPrice}</div>
                        <div>Type de round: {saleRound.roundType}</div>
                        <div>Round type: {saleRound.roundType}</div>
                    </div>
                </div>
            )}

            {stackingRoundId && (
                <div>
                    <StakeRoundDetailFromId roundId={stackingRoundId} userType={userType} />
                </div>
            )}
        </>
    );
};
